module.exports = __webpack_public_path__ + "static/media/06gudh.cda0c805.png";